import React, {FC} from 'react';

import {Toggle} from '../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {SettingsPreferenceItemInheritableProps} from '../settingsPreferencesList';

/*
 * Props.
 */

interface SettingsPreferencesToggleItemProps extends SettingsPreferenceItemInheritableProps<boolean> {
  value?: boolean;
  defaultValue?: boolean;
}

/*
 * Component.
 */

export const SettingsPreferencesToggleItem: FC<SettingsPreferencesToggleItemProps> = (props) => {
  const {updatePreference} = props;
  const value = props.value ?? props.defaultValue;
  return <Toggle isChecked={value} onChange={updatePreference} />;
};
